// Toggle script to toggle classes on multiple elements (use ";" to separate multiple target classes)
// Usage: Add the class 'k-toggle-button' to the button element and add the data attributes 'data-target' and 'data-toggle-class' to the button element
// Example: <button class="k-toggle-button" data-target="target-class" data-toggle-class="d-none">Toggle</button>
// Example: <div class="target-class hidden">Content</div>

(function() {
    function initToggleButtons() {
        const toggleButtons = document.querySelectorAll('.k-toggle-button');

        toggleButtons.forEach(button => {
            const targetClasses = button.getAttribute('data-target').split(';');
            const toggleClass = button.getAttribute('data-toggle-class');
            const selfToggle = button.getAttribute('data-self-toggle');

            if (targetClasses && toggleClass) {
                button.addEventListener('click', function() {
                    // Look in parent first (for sibling elements), then grandparent
                    const parent = this.parentElement;
                    const grandparent = parent.parentElement;

                    targetClasses.forEach(targetClass => {
                        targetClass = targetClass.trim();
                        // Try parent first, then grandparent
                        let target = parent.querySelector(`.${targetClass}`);
                        if (!target) {
                            target = grandparent.querySelector(`.${targetClass}`);
                        }

                        if (target) {
                            target.classList.toggle(toggleClass);
                        }
                    });

                    if (selfToggle) {
                        this.classList.toggle(selfToggle);
                    }
                });
            }
        });
    }

    // Automatically invoke the function on DOMContentLoaded
    document.addEventListener('DOMContentLoaded', function() {
        initToggleButtons();
    });
})();
